import AxiosInstance from "../services/networkServices";

export const createKaraoke = async (payload) => {
    const res = await AxiosInstance.post(`/admin/karaoke/create`, payload);
    return res.data;
}
export const updateKaraoke = async (payload, id) => {
    const res = await AxiosInstance.patch(`/admin/karaoke/update/${id}`, payload);
    return res.data;
}

export const viewKaraoke = async (id) => {
    const res = await AxiosInstance.get(`/admin/karaoke/view/${id}`);
    return res.data;
}

export const listKaraoke = async ({ limit = 20, nextId, searchBy, page, sortBy, sortOrder, status } = {}) => {
    const params = {};
    if (limit) params.limit = limit;
    if (nextId) params.nextId = nextId;
    if (searchBy) params.searchBy = searchBy;
    // Page mode: numbered pages with a total count (admin tables)
    if (page) params.page = page;
    if (sortBy) params.sortBy = sortBy;
    if (sortOrder) params.sortOrder = sortOrder;
    if (status) params.status = status;
    const res = await AxiosInstance.get(`/admin/karaoke/list`, { params });
    return res.data;
}
export const deleteKaraoke = async (id) => {
    const res = await AxiosInstance.delete(`/admin/karaoke/delete/${id}`);
    return res.data;
}